// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/img/common/bullet.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-description-component h3{font-size:--fs-500;font-weight:700;text-transform:lowercase;margin:calc(var(--fs-400)) 0}.dashboard-description-component h3:first-letter{text-transform:uppercase}.dashboard-description-component>ul{list-style-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.dashboard-description-component>ul>li{margin:var(--fs-400) calc(var(--fs-400)/2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
